class CountdownDisplay extends HTMLElement {
  constructor() {
    super();
    const dataEndDate = new Date(
      parseInt(this.dataset.endYear),
      parseInt(this.dataset.endMonth) - 1,
      parseInt(this.dataset.endDay),
      parseInt(this.dataset.endHours),
      parseInt(this.dataset.endMinutes),
      parseInt(this.dataset.endSeconds)
    );
    this.endDate = this.createWIBDate(dataEndDate);
    this.initCountdown();

    setTimeout(() => {
      SkeletonLoaders.stop("coming-soon-countdown");
    }, 1200);
  }

  setDays(value) {
    this.querySelector('.countdown-segment[data-segment-id="days"] .countdown-segment__number').textContent = this.addLeadingZeros(value);
  }

  setHours(value) {
    this.querySelector('.countdown-segment[data-segment-id="hours"] .countdown-segment__number').textContent = this.addLeadingZeros(value);
  }

  setMinutes(value) {
    this.querySelector('.countdown-segment[data-segment-id="minutes"] .countdown-segment__number').textContent = this.addLeadingZeros(value);
  }

  setSeconds(value) {
    this.querySelector('.countdown-segment[data-segment-id="seconds"] .countdown-segment__number').textContent = this.addLeadingZeros(value);
  }

  initCountdown() {
    this.interval = setInterval(() => {
      this.now = new Date();
      const remainingTimeInSec = Math.floor((this.endDate.getTime() - this.now.getTime()) / 1000);

      let remainingDays = Math.floor(remainingTimeInSec / 60 / 60 / 24);
      if (remainingDays < 0) remainingDays = 0;
      this.setDays(remainingDays);

      let remainingHours = Math.floor(remainingTimeInSec / 60 / 60) % 24;
      if (remainingHours < 0) remainingHours = 0;
      this.setHours(remainingHours);

      let remainingMinutes = Math.floor(remainingTimeInSec / 60) % 60;
      if (remainingMinutes < 0) remainingMinutes = 0;
      this.setMinutes(remainingMinutes);

      let remainingSeconds = Math.floor(remainingTimeInSec % 60);
      if (remainingSeconds < 0) remainingSeconds = 0;
      this.setSeconds(remainingSeconds);
    }, 1000);
  }

  createWIBDate(date) {
    return new Date(date.toLocaleString('en-US', { timeZone: "Asia/Jakarta" }));
  }

  addLeadingZeros(value) {
    if (value < 10) {
      return `${0}${value}`
    } else {
      return String(value);
    }
  }
}

customElements.define("countdown-display", CountdownDisplay);